export function initTestimonials() {
  document.querySelectorAll('.testimonials-swiper .swiper').forEach((element) => {
    if (element.swiper) return;
    const count = element.querySelectorAll('.swiper-slide').length;
    if (!count) return;

    new Swiper(element, {
      loop: false,
      initialSlide: count > 1 ? 1 : 0,
      centeredSlides: true,
      slidesPerView: 2.9,
      spaceBetween: 0,
      grabCursor: false,
      speed: 600,
      rewind: true,
      watchSlidesProgress: true,
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 200,
        modifier: 1,
        slideShadows: false,
      },
      scrollbar: {
        el: element.querySelector('.swiper-scrollbar'),
        draggable: true,
        snapOnRelease: true,
        dragSize: 37,
      },
      breakpoints: {
        1000: { slidesPerView: 2.9, centeredSlides: true, effect: 'coverflow' },
        800: { slidesPerView: 2, centeredSlides: false, effect: 'slide' },
        0: { slidesPerView: 1, centeredSlides: false, effect: 'slide' },
      },
    });
  });
}
